import React, { useEffect, useState } from 'react';
import PlantillaScreen from '../../../helpers/PlantillaScreen';
import { LoaderScreen } from '../../../components/LoaderScreen';
import request from '../../../../Helpers/API';
import Swal from 'sweetalert2';
import { useParams } from "react-router-dom";
import DeleteIcon from '@mui/icons-material/Delete';
import { ButtonBack } from '../Util/ButtonBack';
import { SearchSelect } from '../../ConfigurarLeads/SearchSelect';

export const CatSalaActividadesScreen = () => {

    const { id } = useParams();

    const [nombreSala, setNombreSala] = useState("");
    const [grupos, setGrupos] = useState([]);
    const [idGrupoSeleccionado, setIdGrupoSeleccionado] = useState(null);
    const [actividadesGrupo, setActividadesGrupo] = useState([]);
    const [idActividadSeleccionada, setIdActividadSeleccionada] = useState(null);
    const [actividadesAgregadas, setActividadesAgregadas] = useState([]);
    const [loader, setLoader] = useState({ mostrar: false });

    const usuario = 1;

    useEffect(() => {
        request.get(`Sala/Obtener/${id}`)
            .then(result => setNombreSala(result.nombresala))
            .catch(() => Swal.fire("ERROR", "No se pudo obtener la sala", "error"));
    }, [id]);

    useEffect(() => {
        request.get("GrupoActividades/Listado")
            .then(result => setGrupos(result || []))
            .catch(() => Swal.fire("ERROR", "No se pudieron cargar los grupos", "error"));
    }, []);

    const cargarActividadesGuardadas = () => {
        setLoader({ mostrar: true });
        request.get(`SalaActividad/Listado/${id}`)
            .then(result => setActividadesAgregadas(result || []))
            .catch(() => setActividadesAgregadas([]))
            .finally(() => setLoader({ mostrar: false }));
    };

    useEffect(() => {
        cargarActividadesGuardadas();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id]);

    const onSeleccionarGrupo = (idGrupo) => {
        setIdGrupoSeleccionado(idGrupo);
        setIdActividadSeleccionada(null);
        setActividadesGrupo([]);

        if (!idGrupo) return;

        request.get(`Actividad/Listado?idGrupoActividades=${idGrupo}`)
            .then(result => setActividadesGrupo(result || []))
            .catch(() => setActividadesGrupo([]));
    };

    const onAgregarActividad = async () => {
        if (!idActividadSeleccionada) {
            Swal.fire("Aviso", "Seleccione una actividad", "warning");
            return;
        }

        try {
            await request.post(`SalaActividad/Guardar?idSala=${id}&idActividad=${idActividadSeleccionada}&idUsuario=${usuario}`);

            Swal.fire("Correcto", "Actividad agregada correctamente", "success");

            setIdActividadSeleccionada(null);
            cargarActividadesGuardadas();
        } catch {
            Swal.fire("Error", "No se pudo guardar la actividad", "error");
        }
    };

    const onEliminarActividad = async (idRelSalaActividad) => {
        try {
            const response = await request.post(
                "SalaActividad/EliminarPorID",
                {
                    IdRelSalaActividad: idRelSalaActividad,
                    idSala: parseInt(id)
                }
            );

            setActividadesAgregadas(response || []);

            Swal.fire("Correcto", "Actividad eliminada", "success");
        } catch {
            Swal.fire("Error", "No se pudo eliminar", "error");
        }
    };

    return (
        <PlantillaScreen
            titulo={"RELACIÓN DE ACTIVIDADES"}
            className_main={1}
            className={"seguimiento-actividades-contenedor"}
        >
            <LoaderScreen loader={loader} />

            <div className="nsi-contenido nsi-contenido--full">

                <div className="nsi-rol-aviso">
                    <span className="nsi-rol-aviso-badge">SALA</span>
                    {nombreSala || "Cargando..."}
                </div>

                <div className="nsi-card">
                    <div className="nsi-card-header">
                        <span className="nsi-card-header-numero">1</span>
                        <div>
                            <div className="nsi-card-header-titulo">Agregar actividad</div>
                            <div className="nsi-card-header-subtitulo">Elige el grupo y la actividad que aplican en esta sala</div>
                        </div>
                    </div>

                    <div className="lead-form-group">
                        <label>Grupo</label>
                        <SearchSelect
                            options={grupos.map((g) => ({ value: g.idgrupoactividades, label: g.nombregrupoactividades }))}
                            value={idGrupoSeleccionado}
                            onChange={onSeleccionarGrupo}
                            placeholder="Seleccione un grupo"
                        />
                    </div>

                    <div className="lead-form-group">
                        <label>Actividad</label>
                        <div className="csce-opciones-input">
                            <SearchSelect
                                options={actividadesGrupo.map((a) => ({ value: a.idactividad, label: a.nombreactividad }))}
                                value={idActividadSeleccionada}
                                onChange={setIdActividadSeleccionada}
                                placeholder={idGrupoSeleccionado ? "Seleccione una actividad" : "Primero selecciona un grupo"}
                            />
                            <button type="button" onClick={onAgregarActividad}>
                                Agregar
                            </button>
                        </div>
                    </div>
                </div>

                <div className="nsi-card">
                    <div className="nsi-card-header">
                        <span className="nsi-card-header-numero">2</span>
                        <div>
                            <div className="nsi-card-header-titulo">Actividades asignadas</div>
                            <div className="nsi-card-header-subtitulo">
                                {actividadesAgregadas.length} {actividadesAgregadas.length === 1 ? "actividad" : "actividades"}
                            </div>
                        </div>
                    </div>

                    {actividadesAgregadas.length === 0 ? (
                        <div className="csce-vacio">No hay actividades agregadas todavía</div>
                    ) : (
                        <div className="sacc-tabla sacc-tabla-responsables sacc-tabla--compacta scroll">
                            <table className='sacct-container'>
                                <thead>
                                    <tr>
                                        <th>ID SALA</th>
                                        <th>NOMBRE DE ACTIVIDAD</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {actividadesAgregadas.map(a => (
                                        <tr key={a.idRelSalaActividad}>
                                            <td><span className="sacct-id-chip">{a.idSala}</span></td>
                                            <td>{a.nombreactividad}</td>
                                            <td className='sa-eliminar' align="center">
                                                <button
                                                    type="button"
                                                    className='button-eliminar'
                                                    onClick={() => onEliminarActividad(a.idRelSalaActividad)}
                                                >
                                                    <DeleteIcon />
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

            </div>

            <ButtonBack path={"/Permisos/CatalogoSala"} />
        </PlantillaScreen>
    );
};
